import util from '@bmp-vue/core/api/util'

const controller = 'ControladorConta'
export default Object.assign({}, util.GetCrud(controller, null), {
    ObterControlador: function (id) {
        return util.Axios.Get(controller + '/ObterControlador', id);
    },
    ObterControladorSolicitacao: function (codigoSolicitacao) {
        return util.Axios.Get(controller + '/ControladorSolicitacao', codigoSolicitacao);
    }
})
